/*=============================================== AvatarPage ===============================================*/

import { Avatar, Flexbox } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const AvatarPage = () => {
    const items: ItemType[] = [
        {
            title: "With image",
            content: <Avatar size={120} img="/images/pic-avatar.jpg" />,
            code: '<Avatar size={120} img="/images/pic-avatar.jpg" />',
        },
        {
            title: "With letter",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Avatar letter="A" color="primary" />
                    <Avatar letter="A" color="secondary" />
                    <Avatar letter="A" color="success" />
                    <Avatar letter="A" color="danger" />
                    <Avatar letter="A" color="warning" />
                    <Avatar letter="A" color="gray" />
                    <Avatar letter="A" color="black" />
                    <Avatar letter="A" color="white" />
                </Flexbox>
            ),
            code: '<Avatar letter="A" color="primary" />\n<Avatar letter="A" color="secondary" />\n<Avatar letter="A" color="success" />\n<Avatar letter="A" color="danger" />\n<Avatar letter="A" color="warning" />\n<Avatar letter="A" color="gray" />\n<Avatar letter="A" color="black" />\n<Avatar letter="A" color="white" />',
        },
        {
            title: "With icon",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Avatar icon="user" color="primary" size={32} />
                    <Avatar icon="user" color="secondary" size={32} />
                    <Avatar icon="user" color="success" size={32} />
                    <Avatar icon="user" color="danger" size={32} />
                    <Avatar icon="user" color="warning" size={32} />
                    <Avatar icon="user" color="gray" size={32} />
                    <Avatar icon="user" color="black" size={32} />
                    <Avatar icon="user" color="white" size={32} />
                </Flexbox>
            ),
            code: '<Avatar icon="user" color="primary" size={32} />\n<Avatar icon="user" color="secondary" size={32} />\n<Avatar icon="user" color="success" size={32} />\n<Avatar icon="user" color="danger" size={32} />\n<Avatar icon="user" color="warning" size={32} />\n<Avatar icon="user" color="gray" size={32} />\n<Avatar icon="user" color="black" size={32} />\n<Avatar icon="user" color="white" size={32} />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            intro: (
                <>
                    Only if <code>letter</code> and <code>icon</code> are
                    undefined. One of them is required, you can not have the
                    content empty.
                </>
            ),
            subtitle: "img",
            type: "string",
        },
        {
            subtitle: "alt",
            intro: (
                <>
                    Only if <code>img</code> is defined.
                </>
            ),
            type: "string",
            default: "Avatar",
        },
        {
            subtitle: "letter",
            intro: (
                <>
                    Only if <code>img</code> and <code>icon</code> are
                    undefined. One of them is required, you can not have the
                    content empty.
                </>
            ),
            type: "string",
        },
        {
            subtitle: "icon",
            intro: (
                <>
                    Only if <code>img</code> and <code>letter</code> are
                    undefined. One of them is required, you can not have the
                    content empty. {commonProps.addIconCapital}
                </>
            ),
            type: "string",
        },
        {
            subtitle: "iconSize",
            intro: (
                <>
                    Only if <code>icon</code> is defined.
                </>
            ),
            type: "number",
            default: <code>size * 0.7</code>,
        },
        {
            subtitle: "color",
            intro: (
                <>
                    Only if <code>letter</code> or <code>icon</code> are set.
                </>
            ),
            type: "string",
            possibleString: commonProps.allColors,
            default: "primary",
        },
        {
            subtitle: "contentColor",
            intro: (
                <>
                    Only if <code>letter</code> or <code>icon</code> are set.
                </>
            ),
            type: "string",
            possibleString: commonProps.allColors,
            default: "white",
        },
        {
            subtitle: "size",
            type: "number",
            default: 48,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default AvatarPage
